import React from 'react'
import MarketingRow from './MarketingRow'

export default function MarketingRowReversed(props) {
    return <MarketingRow reverse={true} {...props} />
}
